import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const AchievementsPagePageSession = React.lazy(() => import('../achievements/AchievementsPageSession'));
const AchievementsPageHeader = React.lazy(() => import('../achievements/AchievementsPageHeader'));

function AchievementsPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
       <AchievementsPageHeader />
       <AchievementsPagePageSession />
      </Suspense>
    </div>
  );
}

export default AchievementsPage;
